// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li.nav-item{list-style-type:none}.vs__dropdown-toggle{background-color:#fff}", ""]);
// Exports
module.exports = exports;
